<template>
  <div>
    <p id="dashboardItemTitle">Activity Log</p>
    <div class="columns">
      <div class="column is-10">

      </div>

      <div class="column is-2" >
        <b-datepicker
            @input="onDateSelected"
            v-model="selectedDate"
            placeholder="Click to select..."
            icon="calendar-today"
            size="is-small"
            position="is-bottom-left"
            trap-focus
            :max-date="maxDate"
        >
          <template v-slot:trigger>
            <b-button
                icon-left="calendar-today"
                type="is-primary is-small" >{{ selectedDate.toLocaleDateString() }}</b-button>
          </template>
        </b-datepicker>
      </div>
    </div>
    <div style="margin-top: 30px">
      <section v-if="!isLoading">
        <template v-if="tableRows.length < 1" >
          <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
            <span class="ml-2 has-text-grey-lighter">No records to display</span>
          </div>
        </template>
        <b-table
            v-else
            :data="tableRows"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :hoverable="isHoverable"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :sticky-header="stickyHeaders"

            pagination-size="is-small"
            default-sort="reference_id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">


          <b-table-column field="level" label="Level" v-slot="props" centered width="50">
            <b-icon
                icon="record"
                size="is-small"
                v-bind:class="'log-icon-'+props.row.level"
                :title="props.row.level">
            </b-icon>
          </b-table-column>

          <b-table-column field="description" align="left" label="Description" v-slot="props" cellClass="has-text-left">
            <span :class="'log-description-'+props.row.level">{{ props.row.description }}</span>
          </b-table-column>

          <b-table-column field="user_name" label="User" v-slot="props" cellClass="has-text-left">
            {{ props.row.user_id == 0 ? 'SYSTEM' : props.row.name }}
          </b-table-column>

          <b-table-column field="timestamp" label="Timestamp" sortable  v-slot="props" cellClass="has-text-left">
            {{ DateFormat(props.row.timestamp) }}
          </b-table-column>

        </b-table>

      </section>

    </div>
  </div>
</template>
<script>

import axios from "axios";

export default {

  name:'activity-log',

  data(){
    return{
      tableRows:[], // to store pending documents
      isLoading:false,

      showTemplateDeleteModal:false,

      isPaginated: true,
      isHoverable: true,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      stickyHeaders: true,

      template_id:'',
      selectedDate: new Date(),
      maxDate:null,

      columns: [

        {
          field: 'created_by',
          label: 'Created By',
          width: '200',
          centered:true,

        },
        {
          field: 'title',
          label: 'Title',
          centered:true,
        },
        {
          field: 'status',
          label: 'Status',
          centered:true,
        },
        {
          field: 'recipient',
          label: 'Recipient',
          centered:true,
        }
      ]
    }

  },

  methods:{

    DateFormat:function(date)
    {
      //date formatting
      var d = new Date(date)
      var datestring = d.getFullYear() + "-"+ (d.getMonth()+1) + "-"+ d.getDate();

      console.log(datestring);

      //hours formatting
      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;

      var dateTime = datestring +' : '+ strTime
      return dateTime

      // console.log('dateformat js'+datestring);
    },


    //check authentication
    validateToken:function (){
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data.message)
              //load department & template ctg
              component.getDataList()

            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },

    getLogsForSelectedDate: function() {

      var component = this
      var sd = component.selectedDate
      var formattedDate = sd.getFullYear() + "-" + (sd.getMonth() + 1) + "-" + sd.getDate()


      axios.post(component.$base_url + '/agent/activityLogData', {
          auth_token: component.$root.agentAuthToken,
          date: formattedDate
        })
          .then(function (response) {
            console.log('activity log---------')
            console.log(response)
            component.tableRows = response.data.data.list
            component.isLoading = false
          })
          .catch(function (error) {
            console.log(error)

            component.$buefy.toast.open({
              message: "Failed to fetch data",
              type: "is-danger",
            });
          });

    },


    onDateSelected: function(){

      this.getLogsForSelectedDate()

    },
  },

  mounted (){

    this.validateToken()
    this.getLogsForSelectedDate()

    var today = new Date();
    this.maxDate = today

  }
}

</script>

<style scoped>
/* Log Table Styles */

.log-icon-debug{color: #a2a2a2;}

.log-icon-info{color: #1facff;}

.log-icon-notice{color: #f7c200;}

.log-icon-warning{color: #f7c200;}
.log-description-warning{background-color: #fff795;color: #000;}

.log-icon-error{color: #ff0000;}
.log-description-error{color: #ff0000;}

.log-icon-critical{color: #ff0000;}
.log-description-critical{background-color: #f11d1d;color: #FFF;}

.log-icon-alert{color: #ff0000;}
.log-description-alert{background-color: #f11d1d;color: #FFF;}

.log-icon-emergency{color: #ff0000;}
.log-description-emergency{background-color: #f11d1d;color: #FFF;}
</style>

